import { useCallback, useEffect, useState } from "react";
import { getServicePrice, getUserCity } from "../config";

/**
 * Returns the correct price for the user's current city.
 *
 * Usage in any service page:
 *   const { city, cityPrice } = useCityPrice();
 *   <span>₹{cityPrice("mopping", 1500)}</span>
 *
 * When the user switches city in the Header, all components using this
 * hook automatically re-render with the new prices.
 */
export const useCityPrice = () => {
  const [city, setCity] = useState(getUserCity);

  useEffect(() => {
    const sync = () => setCity(getUserCity());
    window.addEventListener("city-updated", sync);
    return () => window.removeEventListener("city-updated", sync);
  }, []);

  // cityPrice(serviceValue, basePrice) → city-specific price or basePrice
  const cityPrice = useCallback(
    (serviceValue, basePrice) => getServicePrice(serviceValue, basePrice, city),
    [city]
  );

  return { city, cityPrice };
};
